export const getLastRouteSegment = (href: string): string | null => {
    const segments = href.split("/");
    const lastSegment = segments[segments.length - 1];
    const withoutQueryString = lastSegment.split("?")[0];

    return withoutQueryString || null;
};
